import { baseUrl } from "../../../../boot";
import axios from "axios";

// Add Inventory
export const addInventory = async (formData) => {
  console.log("Inventory form data ---- ", formData);
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(`${baseUrl}inventory/api/v1/create-inventory`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}


// delete Inventory  API
export const deleteInventory = async (ROWID) => {
  console.log({ ROWID })
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.delete(`${baseUrl}inventory/api/v1/delete-inventory/${ROWID}`, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    console.log("Error is - ", error)
    throw error
  }
}

// update Inventorys
export const updateInventory = async (ROWID, data) => {
  console.log({ data })
  // const ROWID = data.ROWID
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.put(`${baseUrl}inventory/api/v1/update-inventory/${ROWID}`, data, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}

// total count
export const countInventory = async (formData) => {
  console.log(formData,"count")
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.get(`${baseUrl}inventory/api/v1/get-inventory-count`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}

export const getInventoryDetailById = async (id) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.get(`${baseUrl}inventory/api/v1/get-inventory-by-id/${id}`, {
      headers: {
        "auth-token": token,
      }
    })
    // console.log('<<<<<<<<<<<<<<<<<<<<<companires>>>>>>>>>>>>>>>>>',response)
    return response
  } catch (error) {
    throw error
  }
}


// Add Inventory
export const getItemsByCategory = async (formData) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(`${baseUrl}inventory/api/v1/get-inventory-bycategoryID`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}